import React, { Suspense, useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SiteContext } from '@homeplay/app';
import { Loader } from '@homeplay/components';
import { usePaymentMethods } from '@homeplay/hooks';
import LoadFunds from './LoadFunds';
import CashinByVoucher from './CashinByVoucher';
import CashinByPhone from './CashinByPhone';

const HelpPage = React.lazy(() => import('./HelpPage'));

const CashIn = () => {
  const { isTouchUnit } = useContext(SiteContext);
  const { cashin } = usePaymentMethods();
  const hasAnyCashin = cashin.acoinVoucher || cashin.acoinCard || cashin.acoinPhone;

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {!isTouchUnit && hasAnyCashin && (
          <Route path="/" element={<LoadFunds />} />
        )}
        {!isTouchUnit && cashin.acoinPhone && (
          <Route path="/phone" element={<CashinByPhone />} />
        )}
        {(isTouchUnit || !hasAnyCashin) && (
          <Route path="/" element={<CashinByVoucher />} />
        )}
        {(cashin.acoinVoucher || cashin.acoinCard) && (
          <Route path="/voucher" element={<CashinByVoucher />} />
        )}
        <Route path="help" element={<HelpPage />} />
        <Route path="*" element={<Navigate to=".." replace />} />
      </Routes>
    </Suspense>
  );
};

export default CashIn;
